module.exports = __webpack_public_path__ + "media/customizations/cherrycreektrail/back-dd33035d9dd50f58c575cd82caf98260.jpg";